import { Skeleton } from '@common/components';

function SearchDonationCardSkeleton() {
  return (
    <div
      role="status"
      aria-label="지정기부사업 로딩 중"
      className="flex w-full items-center gap-20 mobile-tablet:gap-14"
    >
      <Skeleton className="h-120 w-160 shrink-0 rounded-medium mobile-tablet:h-90 mobile-tablet:w-120" />
      <div className="flex min-w-0 flex-1 flex-col justify-center gap-12 mobile-tablet:gap-8">
        <div className="flex w-full flex-col gap-2">
          <div className="flex w-full items-center justify-between gap-8">
            <Skeleton className="h-16 w-80 rounded-xxsmall" />
            <Skeleton className="h-16 w-60 rounded-xxsmall" />
          </div>
          <Skeleton className="h-20 w-full rounded-xxsmall" />
        </div>
        <div className="flex w-full flex-col gap-4 mobile-tablet:gap-2">
          <Skeleton className="h-4 w-full rounded-pill" />
          <div className="flex w-full items-center justify-between gap-4">
            <Skeleton className="h-16 w-120 rounded-xxsmall" />
            <Skeleton className="h-16 w-32 rounded-xxsmall" />
          </div>
        </div>
      </div>
    </div>
  );
}

interface SearchDonationSkeletonListProps {
  count: number;
  className?: string;
}

export function SearchDonationSkeletonList({
  count,
  className,
}: SearchDonationSkeletonListProps) {
  return (
    <ul
      aria-busy="true"
      className={
        className ??
        'flex flex-col gap-20 mobile-tablet:gap-16 mobile-tablet:px-20'
      }
    >
      {Array.from({ length: count }, (_, index) => (
        <li key={index}>
          <SearchDonationCardSkeleton />
        </li>
      ))}
    </ul>
  );
}
